module.exports = __webpack_public_path__ + "img/net.1e01d6d9.png";